/**
 * How much a client still owes on a recorded cancellation-fee payment (#621).
 *
 * A "Final payment" is the full amount or an agreed settlement, with no
 * further payment expected. It settles everything it covers even when the
 * agreed figure was lower than the fee (e.g. a 50% hardship settlement), so
 * nothing is owed. Only a partial payment leaves its stored remainder owing.
 *
 * Records saved before the #621 backend fix kept "fee minus paid" as their
 * outstandingBalance even when final, which is why the red "Outstanding
 * Balance" row showed on settled claims. Records with no isFinal flag are
 * treated as partial, exactly as before.
 */
export interface RecordedPaymentBalance {
  outstandingBalance?: number | null;
  isFinal?: boolean | null;
}

export function amountStillOwed(payment?: RecordedPaymentBalance | null): number {
  if (!payment || payment.isFinal === true) return 0;
  const balance = Number(payment.outstandingBalance);
  return Number.isFinite(balance) && balance > 0 ? balance : 0;
}
